import {ProfileSkills, ProfileSkillsFromProps, SkillTag} from "@betrue/ui";
import styled from "styled-components";
import Autocomplete, {createFilterOptions} from '@material-ui/lab/Autocomplete';
import {Popper, TextField} from "@material-ui/core";
import {Skill, StyledBaseProps} from "@betrue/shared/interfaces";
import {useState} from "react";

const filter = createFilterOptions<SkillOption>();

export interface SkillOption extends Skill {
  inputValue?: string
  key: string
  label: string
}

interface ProfileSkillsFromViewProps extends ProfileSkillsFromProps, StyledBaseProps {
  addSkill: (skill: SkillOption) => void
  baseSkills: SkillOption[],
  autoCompleteOnChange: (newValue) => void,
  autoCompleteOptions: SkillOption[],
  autoCompleteOnInputChange: (value: string) => void
}

export const ProfileSkillsFromView = styled((props: ProfileSkillsFromViewProps) => {
  // force rendering
  const [key, setkey] = useState(Math.random().toString(36).substring(2, 15))
  const [value, setValue] = useState('')

  return (

    <span className={props.className}>


    <div style={{paddingBottom:'20px'}}>
      <h2>{props.skillsLinkedToYourJobTitle}</h2>
      {props.baseSkills?.map((defaultSkill) => (
        <span key={defaultSkill.key}>
          <SkillTag skill={defaultSkill} onAdd={(skill) => props.addSkill(skill)}/>
        </span>
      ))}
      </div>
      <Autocomplete
        style={{paddingBottom:'20px'}}
        key={key}
        PopperComponent={(props) => (<Popper disablePortal={true} {...props}  />)}
        onInputChange={(event, value, reason) => {
          if (reason === 'input' && value) {
            props.autoCompleteOnInputChange(value)
          }
        }}
        onChange={(event, value, reason) => {
          if (reason === 'select-option' && value) {
            props.autoCompleteOnChange(value)
            setkey(Math.random().toString(36).substring(2, 15))
            setValue('')
          }
        }}
        filterOptions={(options: SkillOption[], params) => {
          const filtered = filter(options, params);

          // Suggest the creation of a new value
          if (params.inputValue !== '') {
            filtered.push({
              removed:false,
              version:0,
              key: params.inputValue,
              label: `Ajouter "${params.inputValue}"`,
              id: undefined,
              usageCount: undefined
            });
          }

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={props.autoCompleteOptions}
        renderOption={(option) => option.label}
        freeSolo
        renderInput={(params) => (
          <TextField {...params} label="illustrator, css, After effect" variant="outlined"/>
        )}
        getOptionLabel={(option: SkillOption) => {
          // Value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.label;
        }}

      />
      <ProfileSkills
      canUpdate={props.canUpdate}
      canDelete={props.canDelete}
      experiencesHeader={props.experiencesHeader}
      experiencesHeaderHelper={props.experiencesHeaderHelper}
      skillsHeaderHelper={props.skillsHeaderHelper}
      skillsHeader={props.skillsHeader}/>
  </span>

  )
})`
  & > div > span {
    display: inline-block;
  }
`
